import React from "react";
var __jsx = React.createElement;
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import Countdown from "react-countdown";
import stl from "./CampaignModal.module.css";
import { useEffect, useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
var CampaignModal = function CampaignModal(_ref) {
  var _dataFromPost$cash, _dataFromPost$cash2, _dataFromPost$cash3, _dataFromPost$cash4, _dataFromPost$cash5, _dataFromPost$cash6, _dataFromPost$finance, _dataFromPost$finance2, _dataFromPost$finance3, _dataFromPost$finance4, _dataFromPost$finance5;
  var modalName = _ref.modalName,
    doClose = _ref.doClose,
    campaignData = _ref.campaignData,
    isPostModal = _ref.isPostModal,
    dataFromPost = _ref.dataFromPost;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useState = useState(0),
    tab = _useState[0],
    setTab = _useState[1];
  useEffect(function () {
    if (dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.cash) {
      setTab(0);
    } else {
      setTab(1);
    }
  }, [dataFromPost]);
  return /*#__PURE__*/React.createElement(BottomSheetPopup, {
    blueCloseIcon: true,
    show: modalName,
    onClose: function onClose() {
      return doClose();
    }
  }, isPostModal ? /*#__PURE__*/React.createElement("div", {
    className: stl.tabsContainer
  }, /*#__PURE__*/React.createElement("strong", null, (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.cash) && (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.finance) && t("تفاصيل العروض", {
    ns: "web_common"
  }), (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.cash) && !(dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.finance) && t("عرض الكاش", {
    ns: "web_common"
  }), !(dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.cash) && (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.finance) && t("عرض التمويل", {
    ns: "web_common"
  })), (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.cash) && (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.finance) && /*#__PURE__*/React.createElement("div", {
    className: stl.tabsHead
  }, (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.cash) && /*#__PURE__*/React.createElement("div", {
    className: tab == 0 ? stl.active : "",
    onClick: function onClick() {
      setTab(0);
    }
  }, "\uD83D\uDCB5", " ", t("عرض الكاش", {
    ns: "web_common"
  })), (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.finance) && /*#__PURE__*/React.createElement("div", {
    className: tab == 1 ? stl.active : "",
    onClick: function onClick() {
      setTab(1);
    }
  }, "\uD83C\uDFE6", " ", t("عرض التمويل", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.tabsContent,
    style: {
      transform: tab == 1 ? lang === "ar" ? "translate(calc(100% + 20px), 0px)" : "translate(calc(-100% - 20px), 0px)" : undefined
    }
  }, (tab == 0 || true) && /*#__PURE__*/React.createElement("div", null, (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.cash) && /*#__PURE__*/React.createElement(React.Fragment, null, (dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash = dataFromPost.cash) === null || _dataFromPost$cash === void 0 ? void 0 : _dataFromPost$cash.desktop_image) && /*#__PURE__*/React.createElement("img", {
    src: dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash2 = dataFromPost.cash) === null || _dataFromPost$cash2 === void 0 ? void 0 : _dataFromPost$cash2.desktop_image,
    alt: "img"
  }), dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.counter_timestamp ? /*#__PURE__*/React.createElement("div", {
    className: stl.countdownWrapper
  }, /*#__PURE__*/React.createElement("strong", null, t("باقي على العرض:", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(Countdown, {
    date: !(dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.finance) ? (dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash3 = dataFromPost.cash) === null || _dataFromPost$cash3 === void 0 ? void 0 : _dataFromPost$cash3.counter_timestamp) * 1000 : (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref2) {
      var hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        days = _ref2.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " ", ":", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })) : null, /*#__PURE__*/React.createElement("h2", null, dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash4 = dataFromPost.cash) === null || _dataFromPost$cash4 === void 0 ? void 0 : _dataFromPost$cash4.text, " "), (dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash5 = dataFromPost.cash) === null || _dataFromPost$cash5 === void 0 ? void 0 : _dataFromPost$cash5.description) && /*#__PURE__*/React.createElement("div", {
    className: stl.description,
    dangerouslySetInnerHTML: {
      __html: dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$cash6 = dataFromPost.cash) === null || _dataFromPost$cash6 === void 0 ? void 0 : _dataFromPost$cash6.description
    }
  }))), (tab == 1 || true) && /*#__PURE__*/React.createElement("div", null, (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.finance) && /*#__PURE__*/React.createElement(React.Fragment, null, (dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$finance = dataFromPost.finance) === null || _dataFromPost$finance === void 0 ? void 0 : _dataFromPost$finance.desktop_image) && /*#__PURE__*/React.createElement("img", {
    src: dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$finance2 = dataFromPost.finance) === null || _dataFromPost$finance2 === void 0 ? void 0 : _dataFromPost$finance2.desktop_image,
    alt: "img"
  }), /*#__PURE__*/React.createElement("h2", null, dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$finance3 = dataFromPost.finance) === null || _dataFromPost$finance3 === void 0 ? void 0 : _dataFromPost$finance3.text), (dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$finance4 = dataFromPost.finance) === null || _dataFromPost$finance4 === void 0 ? void 0 : _dataFromPost$finance4.description) && /*#__PURE__*/React.createElement("div", {
    className: stl.description,
    dangerouslySetInnerHTML: {
      __html: dataFromPost === null || dataFromPost === void 0 ? void 0 : (_dataFromPost$finance5 = dataFromPost.finance) === null || _dataFromPost$finance5 === void 0 ? void 0 : _dataFromPost$finance5.description
    }
  }))))) : /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("strong", null, modalName === "finance" ? t("عرض التمويل", {
    ns: "web_common"
  }) : t("عرض الكاش", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("img", {
    src: campaignData === null || campaignData === void 0 ? void 0 : campaignData.desktop_image,
    alt: ""
  }), campaignData !== null && campaignData !== void 0 && campaignData.counter_timestamp ? /*#__PURE__*/React.createElement("div", {
    className: stl.countdownWrapper
  }, /*#__PURE__*/React.createElement("strong", null, t("باقي على العرض:", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(Countdown, {
    date: (campaignData === null || campaignData === void 0 ? void 0 : campaignData.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref3) {
      var hours = _ref3.hours,
        minutes = _ref3.minutes,
        seconds = _ref3.seconds,
        days = _ref3.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " :", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })) : null, /*#__PURE__*/React.createElement("h2", null, campaignData === null || campaignData === void 0 ? void 0 : campaignData.text, " "), /*#__PURE__*/React.createElement("div", {
    className: stl.description,
    dangerouslySetInnerHTML: {
      __html: campaignData === null || campaignData === void 0 ? void 0 : campaignData.description
    }
  })));
};
export default CampaignModal;